// Why someone reports a page (the same list profile_reports accepts).
// Shared by the client and the Pages Functions; keep it dependency free.

export const REPORT_REASONS = [
  { id: 'phishing', label: 'Phishing or scam' },
  { id: 'malware', label: 'Malware or a harmful download' },
  { id: 'spam', label: 'Spam' },
  { id: 'impersonation', label: 'Pretending to be someone else' },
  { id: 'hate', label: 'Hate or harassment' },
  { id: 'sexual', label: 'Sexual content' },
  { id: 'other', label: 'Something else' },
] as const;

export type ReportReason = (typeof REPORT_REASONS)[number]['id'];

export const REPORT_DETAIL_MAX = 500;
